module.exports = __webpack_public_path__ + "static/media/ic_launcher.23110fba.png";